import { render, staticRenderFns } from "./CreditManagement.vue?vue&type=template&id=974ebd1a&scoped=true&"
import script from "./CreditManagement.vue?vue&type=script&lang=js&"
export * from "./CreditManagement.vue?vue&type=script&lang=js&"
import style0 from "./CreditManagement.vue?vue&type=style&index=0&id=974ebd1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974ebd1a",
  null
  
)

export default component.exports